export default __webpack_public_path__ + "static/media/logo.52cb0935.png";